import { render, staticRenderFns } from "./UserIntro.vue?vue&type=template&id=38a876f0"
import script from "./UserIntro.vue?vue&type=script&lang=ts"
export * from "./UserIntro.vue?vue&type=script&lang=ts"
import style0 from "./UserIntro.vue?vue&type=style&index=0&id=38a876f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports